module.exports = __webpack_public_path__ + "static/media/db-logo.38975d34.png";